import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import { LogoComponent } from './navbar/logo/logo.component';
import { MenuToggleComponent } from './navbar/menu-toggle/menu-toggle.component';
import { SearchInputComponent } from './navbar/search-input/search-input.component';
import { ActionButtonsComponent } from './navbar/action-buttons/action-buttons.component';
import { CartButtonComponent } from './navbar/cart-button/cart-button.component';
import { LayoutComponent } from './layout.component';
import { LanguageSwitcherComponent } from './navbar/language-switcher/language-switcher.component';
import { MegaMenuComponent } from './navbar/mega-menu/mega-menu.component';
import { SearchResultsComponent } from './navbar/search-results/search-results.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CartDropdownComponent } from './navbar/cart-dropdown/cart-dropdown.component';
import { AuthDropdownComponent } from './navbar/auth-dropdown/auth-dropdown.component';
import { FooterComponent } from './footer/footer.component';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { LoadingSpinnerComponent } from '../../shared/components/loading-spinner/loading-spinner.component';
import { NewsletterSignupComponent } from '../marketplace/components/newsletter-signup/newsletter-signup.component';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';

@NgModule({
  declarations: [
    NavbarComponent,
    LogoComponent,
    MenuToggleComponent,
    SearchInputComponent,
    ActionButtonsComponent,
    CartButtonComponent,
    LayoutComponent,
    LanguageSwitcherComponent,
    MegaMenuComponent,
    SearchResultsComponent,
    CartDropdownComponent,
    AuthDropdownComponent,
    FooterComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    LoadingSpinnerComponent,
    NewsletterSignupComponent,
    TranslatePipe,
  ],
  exports: [NavbarComponent, LayoutComponent],
})
export class LayoutModule { }
// Triggering re-compilation for CartDropdownComponent Input changes
